import { toVehicleReference } from "./to-vehicle-reference";
import type { SearchVehicleResultDto } from "@/lib/api";
import type { SearchVehicleResult } from "../../types/vehicle.types";

export function toSearchVehicleResult(
	dto: SearchVehicleResultDto
): SearchVehicleResult {
	return {
		id: dto.vehicle?.id,
		vehicle: dto.vehicle ? toVehicleReference(dto.vehicle) : undefined,
		batteryStatus: dto.batteryStatus,
		homePosition: dto.homePosition,
		lastPosition: dto.lastPosition,
		distanceFromHomePosition: dto.distanceFromHomePosition,
	};
}
